(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define("Promotion", [
            'jquery',
            'request',
            'main.js',
            'magnificPopup'
        ], factory);
    } else if (typeof module === 'object' && module.exports) {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory(
            require('jquery'),
            require('request'),
            require('main.js'),
            require('magnificPopup')
        );
    } else {
        // Browser globals (root is window)
        root.returnExports = factory(
            root.jquery,
            root.main,
            root.Request,
            root.magnificPopup
        );
    }
}(typeof self !== 'undefined' ? self : this, function ($, Request, main, magnificPopup) {
    function ClearFrom(element, datas) {
        element.find('input').each(function () {
            $(this).removeClass('has-error');
            $(this).removeClass('not-empty');
            switch ($(this).prop('type')) {
                case "checkbox":
                    $(this).removeAttr('checked');
                    $(this).trigger('click');
                    break;
                case "hidden":

                    break;
                default:
                    $(this).val(null);

                    break;
            }
        });
        element.find('.form-message').remove();
        element.find('p.error').remove();
        element.find('[name="promotionSubmit"]').removeClass('active').removeAttr('disabled').html(datas.buttonHtml);
        // Ez a művelet miért a ClearFrom-ba került. Ja meg nem clearFORM?
        element.prepend("<div class='form-message has-success'><p>" + element.data('success-text') + "</p></div>");
    }

    var addZipEventHandler = function () {
        $(document).on('focusout', '#zip', function (e) {
            let $this = $(this);
            let $city = $('#city');
            let zip = $this.val();

            new Request(null, {
                requestOptions: {
                    method: "POST",
                    data: {
                        zip: zip
                    },
                    url: window.serverVariables.settlementJsonUrl
                },
                success: function (response, request) {
                    $city.val(response.data.city);
                    $city.trigger("change");
                },
                error: function () {
                  console.error("Zip error");
                }
            });
        });
    };

    var addFormEventHandler = function () {
        let formSelector = '#promotionForm';
        let $formSelector = $(document).find(formSelector);
        let buttonHtml = $formSelector.find('[name="promotionSubmit"]').html();

        $formSelector.w5request({
            selector: formSelector,
            onEvent: function (event, request) {
                window.enableAjax = false;

                window.sendAjax = function () {
                    window.enableAjax = true;
                    request.setElement();
                    request.request();
                };

                window.grecaptcha.execute();
            },
            beforeSend: function (xhr, setting) {
                if ( !window.enableAjax ) {
                    return false;
                } else {
                    let $button = this.find('[name="promotionSubmit"]'),
                        tmpText = $button.data('loading-text');

                    $button.attr('disabled', 'disabled').addClass('active').html(tmpText);
                }
            },
            success: function (response, request) {
                let $outerForm = this;

                resetCaptcha();

                $.magnificPopup.open({
                    type: 'ajax',
                    closeOnBgClick: false,
                    items: [
                        {
                            src: response.data.html,
                            type: "inline"
                        }
                    ],
                    closeMarkup: '<div class="mfp-close"><button type="button"><div><i class="icon icon-close"></i><span>Bezár</span></div></button></div>',
                    callbacks: {
                        open: function () {
                            $('body').css('overflow', 'hidden');
                            this.contentContainer.attr('id', 'gdpr-modal');

                            $('.mfp-close').slice(1).remove();

                            $('.mfp-close').on('click touchstart', function () {
                                $.magnificPopup.close();
                                $(this).off('click touchstart');
                            });

                            let selector = "#gdpr-form";

                            let outerFormData = "";

                            $(document).find(formSelector).find('input').each(function () {
                                let $input = $(this);

                                if ( $input.attr('type') !== "checkbox" ) {
                                    outerFormData += "&" + $input.serialize();
                                }
                            });

                            outerFormData = outerFormData.slice(1);

                            let $selector = $(document).find(selector);

                            $selector.w5request({
                                selector: selector,
                                onEvent: function (event, request) {
                                    $selector = $(document).find(selector);

                                    $('#promotionForm').unbind('submit');

                                   // event.stopImmediatePropagation();

                                    request.setRequestData(outerFormData + "&" + $selector.serialize());

                                },
                                success: function (response, request) {
                                    ClearFrom($(formSelector), {buttonHtml: buttonHtml});

                                    request.removeEventListener();

                                    $.magnificPopup.close();

                                    $('#promotionForm').bind('submit');
                                },
                                error: function (response, request) {
                                    request.removeEventListener();

                                    this.replaceWith(response.data.html);
                                    console.log(response);
                                }
                            });
                        },
                        close: function () {
                            $('body').css('overflow', 'visible');
                            $outerForm.find('[name="promotionSubmit"]').removeClass('active').removeAttr('disabled').html(buttonHtml);
                            $('html,body').animate({scrollTop: $outerForm.offset().top - 20},'slow');
                        }
                    }
                });

            },
            error: function (response, arg2, arg3) {
                this.replaceWith(response.data.html);
                this.find('[name="promotionSubmit"]').removeClass('active').removeAttr('disabled').html(buttonHtml);
                window.onloadCaptchaCallback();
                console.log(response);
            },
        });
    };

    window.onloadCaptchaCallback = function () {
        window.captchaID = grecaptcha.render('g-recaptcha', {'sitekey': window.serverVariables.siteKey});
    };

    var resetCaptcha = function () {
        if (window.grecaptcha) {
            grecaptcha.reset(window.captchaID)
        }
    };

    $(function () {
        addZipEventHandler();
        addFormEventHandler();

        $(document).on('change', '#checkAll', function () {
            let checked = this.checked;

            $("#gdpr-form").find('input[type="checkbox"]').not(this).prop('checked', checked).trigger('change');
        });
    });
}));



//////////////////
// WEBPACK FOOTER
// ./js/pages/promotion/index.js
// module id = 5
// module chunks = 0 1 2 3 4